module.exports = __webpack_public_path__ + "assets/img/0b0e2601e498d5a77491438c58f21493.svg";